/**
 * Do not edit directly
 * Generated on Thu, 15 Dec 2022 18:46:44 GMT
 */


module.exports = {
  FuelColorBrandPrimary: "#367c2b",
  FuelColorBrandSecondary: "#ffde00",
  FuelColorBackgroundActionDefaultBase: "#ffffff",
  FuelColorBackgroundActionDefaultHovered: "#f7f7f7",
  FuelColorBackgroundActionDefaultPressed: "#ebf2ea",
  FuelColorBackgroundActionDefaultSelected: "#f4f8f4",
  FuelColorBackgroundActionDefaultSelectedBar: "#367c2b",
  FuelColorBackgroundActionPrimaryBase: "#ffde00",
  FuelColorBackgroundActionPrimaryHovered: "#eacb00",
  FuelColorBackgroundActionPrimaryPressed: "#ceb300",
  FuelColorBackgroundActionSecondaryBase: "#ffffff",
  FuelColorBackgroundActionSecondaryHovered: "#f7f7f7",
  FuelColorBackgroundActionSecondaryPressed: "#dddddd",
  FuelColorBackgroundActionTertiaryBase: "rgba(0, 0, 0, 0)",
  FuelColorBackgroundActionTertiaryHovered: "#f4f8f4",
  FuelColorBackgroundActionTertiaryPressed: "#d2e1cf",
  FuelColorBackgroundInteractiveDefaultBase: "#367c2b",
  FuelColorBackgroundWhite: "#ffffff",
  FuelColorBackgroundGray: "#f0f0f0",
  FuelColorBackgroundBrand: "#367c2b",
  FuelColorTextLink: "#367c2b",
  FuelColorTextLinkHovered: "#000000",
  FuelColorTextActionDefault: "#454545",
  FuelColorTextActionPrimary: "#000000",
  FuelColorTextActionSecondary: "#454545",
  FuelColorTextActionTertiary: "#367c2b",
  FuelColorTextPrimary: "#1b1b1b",
  FuelColorTextSecondary: "#454545",
  FuelColorTextTertiary: "#666666",
  FuelColorTextDisabled: "#b3b3b3",
  FuelColorTextBody: "#1b1b1b",
  FuelColorTextHeading: "#1b1b1b",
  FuelColorTextIcon: "#666666",
  FuelColorTextBrandPrimary: "#367c2b",
  FuelColorFocused: "#1b1b1b",
  FuelColorBorderSelected: "#367c2b",
  FuelColorBorderBase: "#cccccc",
  FuelColorBorderLight: "#dddddd",
  FuelColorBorderDark: "#b3b3b3",
  FuelColorAlertSuccessBackground: "#f4f8f4",
  FuelColorAlertSuccessIcon: "#367c2b",
  FuelColorAlertSuccessBorder: "#99bd93",
  FuelColorAlertErrorBackground: "#fdf6f6",
  FuelColorAlertErrorIcon: "#c21020",
  FuelColorAlertErrorBorder: "#dd737e",
  FuelColorAlertInfoBackground: "#f3f7fb",
  FuelColorAlertInfoIcon: "#005db1",
  FuelColorAlertInfoBorder: "#7aabd6",
  FuelColorAlertWarningBackground: "#fef6ea",
  FuelColorAlertWarningIcon: "#f99700",
  FuelColorAlertWarningBorder: "#ffbb52",
  FuelColorGray50: "#f7f7f7",
  FuelColorGray100: "#f0f0f0",
  FuelColorGray200: "#dddddd",
  FuelColorGray300: "#cccccc",
  FuelColorGray400: "#b3b3b3",
  FuelColorGray500: "#919191",
  FuelColorGray600: "#767676",
  FuelColorGray700: "#666666",
  FuelColorGray800: "#454545",
  FuelColorGray900: "#333333",
  FuelColorGray1000: "#1b1b1b",
  FuelColorYellow50: "#fff8cd",
  FuelColorYellow100: "#fff29a",
  FuelColorYellow200: "#ffde00",
  FuelColorYellow300: "#eacb00",
  FuelColorYellow400: "#ceb300",
  FuelColorYellow500: "#a69100",
  FuelColorYellow600: "#877600",
  FuelColorYellow700: "#756600",
  FuelColorYellow800: "#504500",
  FuelColorYellow900: "#3b3400",
  FuelColorYellow1000: "#201c00",
  FuelColorGreen50: "#f4f8f4",
  FuelColorGreen100: "#ebf2ea",
  FuelColorGreen200: "#d2e1cf",
  FuelColorGreen300: "#bbd3b7",
  FuelColorGreen400: "#99bd93",
  FuelColorGreen500: "#699e61",
  FuelColorGreen600: "#438539",
  FuelColorGreen700: "#367c2b",
  FuelColorGreen800: "#224e1b",
  FuelColorGreen900: "#1a3b14",
  FuelColorGreen1000: "#0e1f0b",
  FuelColorBlack: "#000000",
  FuelColorWhite: "#ffffff",
  FuelColorJdGreen: "#367c2b",
  FuelColorJdYellow: "#ffde00",
  FuelColorJdCharcoal: "#54585a",
  FuelColorJdConstructionYellow: "#f2a900",
  FuelSpacing0: "0rem",
  FuelSpacing1: "0.25rem",
  FuelSpacing2: "0.5rem",
  FuelSpacing3: "0.75rem",
  FuelSpacing4: "1rem",
  FuelSpacing6: "1.5rem",
  FuelSpacing8: "2rem",
  FuelSpacing10: "2.5rem",
  FuelSpacing12: "3rem",
  FuelSpacing16: "4rem",
  FuelBorderRadiusBase: ".25rem",
  FuelBorderRadiusNone: "0",
  FuelBorderRadiusSm: ".125rem",
  FuelBorderRadiusMd: ".25rem",
  FuelBorderRadiusLg: ".5rem",
  FuelBorderRadiusXl: ".75rem",
  FuelBorderRadius2xl: "1rem",
  FuelBorderRadiusFull: "9999px",
  FuelFontFamilyBase: "'Open Sans', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', Helvetica, Arial, 'Nimbus Sans L', 'FreeSans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
  FuelFontFamilyHeading: "'Open Sans', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', Helvetica, Arial, 'Nimbus Sans L', 'FreeSans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
  FuelFontFamilyJdSansProMedium: "'JDSansPro-Medium', 'Open Sans', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', Helvetica, Arial, 'Nimbus Sans L', 'FreeSans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
  FuelFontFamilyJdSansProBold: "'JDSansPro-Bold', 'Open Sans', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', Helvetica, Arial, 'Nimbus Sans L', 'FreeSans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
  FuelFontWeightBase: "400",
  FuelFontWeightRegular: "400",
  FuelFontWeightSemibold: "600",
  FuelFontWeightBold: "700",
  FuelFontSizeBase: "1rem",
  FuelFontSizeXs: ".75rem",
  FuelFontSizeSm: ".875rem",
  FuelFontSizeMd: "1rem",
  FuelFontSizeLg: "1.125rem",
  FuelFontSizeXl: "1.25rem",
  FuelFontSize2xl: "1.5rem",
  FuelFontSize3xl: "1.875rem",
  FuelFontSize4xl: "2.25rem",
  FuelFontSize5xl: "3rem",
  FuelFontSize6xl: "3.5rem",
  FuelFontSizeHeading1: "1.5rem",
  FuelFontSizeHeading2: "1.25rem",
  FuelFontSizeHeading3: "1.125rem",
  FuelFontSizeHeading4: "1rem",
  FuelFontSizeHeading5: ".875rem",
  FuelFontSizeHeading6: ".875rem",
  FuelFontSizeBody: "1rem",
  FuelFontSizeIcon: ".625rem",
  FuelLineHeightBase: "1.5rem",
  FuelLineHeightXs: "1rem",
  FuelLineHeightSm: "1.25rem",
  FuelLineHeightMd: "1.5rem",
  FuelLineHeightLg: "1.75rem",
  FuelLineHeightXl: "1.75rem",
  FuelLineHeight2xl: "2rem",
  FuelLineHeight3xl: "2.25rem",
  FuelLineHeight4xl: "2.5rem",
  FuelLineHeight5xl: "3rem",
  FuelLineHeight6xl: "3.5rem",
  FuelShadowBase: "0px 0px 5px 0px rgba(27, 27, 27, .05), 0px 1px 2px 0px rgba(27, 27, 27, .15), 0px 0px 0px 1px rgba(51, 51, 51, .05), 0px 1px 3px 0px rgba(51, 51, 51, .15)",
  FuelShadowNone: "none",
  FuelShadowXs: "0px 2px 4px -1px rgba(0, 0, 0, 0.1)",
  FuelShadowSm: "0px 1px 3px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px 0px rgba(0, 0, 0, 0.06)",
  FuelShadowMd: "0px 0px 5px 0px rgba(27, 27, 27, .05), 0px 1px 2px 0px rgba(27, 27, 27, .15), 0px 0px 0px 1px rgba(51, 51, 51, .05), 0px 1px 3px 0px rgba(51, 51, 51, .15)",
  FuelShadowLg: "0px 4px 6px -1px rgba(27, 27, 27, 0.15), 0px 0px 0px 1px rgba(51, 51, 51, 0.05)",
  FuelShadowXl: "0px 1px 10px 0px rgba(27, 27, 27, 0.2), 0px -1px 20px 0px rgba(27, 27, 27, 0.1)",
  FuelShadow2xl: "0px 26px 80px 0px rgba(27, 27, 27, 0.2), 0px 0px 1px 0px rgba(27, 27, 27, 0.2)",
  FuelShadowInsetButton: "inset 0 -1px 1px rgba(0,0,0, .2)",
  FuelShadowFocused: "0 0 0 2px #ffffff, 0 0 0 4px #1b1b1b",
};